export const TBCLS = [
  '.codigger-app-window-titlebar',
  '.title-bar-wrapper',
  '.codigger-terminai-menu',
  '.title-bar',
  '.meeting-titlebar-bar'
];
